"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var InboxIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(InboxIcon, _React$PureComponent);

  function InboxIcon() {
    _classCallCheck(this, InboxIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(InboxIcon).apply(this, arguments));
  }

  _createClass(InboxIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'inbox-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M11,4.40444307 L11.1167533,4.41116025 C11.6145765,4.46883728 12,4.8909147 12,5.40438474 L12,5.40438474 L12,11.0000583 C12,11.5520261 11.553,12 11,12 L11,12 L1,12 C0.447,12 0,11.5520261 0,11.0000583 L0,11.0000583 L0,5.40438474 C0,4.851417 0.447,4.40444307 1,4.40444307 C1.323,4.40444307 1.636,4.51643654 1.884,4.72342447 L1.884,4.72342447 L5.68,7.88723991 C5.865,8.04223087 6.135,8.04223087 6.32,7.88723991 L6.32,7.88723991 L10.116,4.72342447 C10.364,4.51643654 10.677,4.40444307 11,4.40444307 L11,4.40444307 Z M6.75,2.999 L8.686,2.999925 C9.145,2.999925 9.361,3.56889181 9.018,3.87387402 L9.018,3.87387402 L6.332,6.26073479 C6.144,6.42872499 5.857,6.42872499 5.668,6.26073479 L5.668,6.26073479 L2.983,3.87387402 C2.64,3.56889181 2.855,2.999925 3.315,2.999925 L3.315,2.999925 L5.25,2.999 L5.25,0.000399976668 L6.75,0.000399976668 L6.75,2.999 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return InboxIcon;
}(_react.default.PureComponent);

exports.default = InboxIcon;
InboxIcon.defaultProps = {
  color: 'inherit'
};
InboxIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};